const dangerHandle = () => import('@/pages/dangerHandle/index')
const dangerHandleCreate = () => import('@/pages/dangerHandle/dangerHandleCreate')
export default [{
  path: '/dangerHandle',
  name: '/dangerHandle',
  component: dangerHandle,
  meta: {
    storeKey: 'trs.dangerHandle'
  }
},
{
  path: '/dangerHandleCreate',
  name: '/dangerHandleCreate',
  component: dangerHandleCreate,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/dangerHandle/index.js